// src/components/Profile/TimedPill.jsx
import React, { useContext, useEffect, useRef } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';
import { TooltipContext }   from './TooltipContext';

const TimedPill = ({ id, label, tooltipText }) => {
  const { openId, setOpenId } = useContext(TooltipContext);
  const targetRef = useRef(null);
  const timerRef  = useRef(null);

  useEffect(() => {
    return () => clearTimeout(timerRef.current);
  }, []);

  const show = e => {
    // prevent nested onClick / onTouchStart from flipping states
    e && e.stopPropagation();
    clearTimeout(timerRef.current);
    setOpenId(id);
    timerRef.current = setTimeout(() => {
      setOpenId(curr => curr === id ? null : curr);
    }, 1200);
  };

  const hide = () => {
    clearTimeout(timerRef.current);
    setOpenId(curr => curr === id ? null : curr);
  };

  return (
    <>
      <span
        ref={targetRef}
        className="pill"
        onClick={show}
        onTouchStart={show}
        onMouseEnter={show}
        onMouseLeave={hide}
      >
        {label}
      </span>

      <Overlay
        target={targetRef.current}
        show={openId === id}
        placement="top"
        transition={false}
        rootClose={true}       /* now tapping outside always closes */
        onHide={hide}
      >
        <Tooltip id={`tooltip-${id}`} transition="true">
          {tooltipText}
        </Tooltip>
      </Overlay>
    </>
  );
};

export default TimedPill;
